import { apiSlice } from "./apiSlice";
export const actionTrackerSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({

        addClaimTrackerComment: builder.mutation({
            query: (body) => ({
                url: `Claim/comments`,
                method: 'POST',
                body,
            }),
            invalidatesTags: ['allClaimTrackerComment']
        }),
        getClaimTrackerComments: builder.query({
            query: ({ commentId, ...params }) => ({
                url: `Claim/${commentId}/comments`,
                params,
            }),
            keepUnusedDataFor: 0,
            refetchOnMountOrArgChange: true,
            providesTags: ["allClaimTrackerComment"],
        }),

        getAttachmentsByComment: builder.query({
            query: (commentId) => ({
                url: `Claim/comments/${commentId}/attachments`,
            }),
            keepUnusedDataFor: 0,
            refetchOnMountOrArgChange: true,
        }),



    }),
});

export const {
    useAddClaimTrackerCommentMutation,
    useGetAttachmentsByCommentQuery,
    useGetClaimTrackerCommentsQuery
} = actionTrackerSlice;
